import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-sujet-card',
  templateUrl: './note-sujet-card.component.html',
  styleUrls: ['./note-sujet-card.component.scss']
})
export class NoteSujetCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
